module.exports = {
    showStats: false,
    resolution: {width:1920, height:1080},
    loadscreen: {
        loadbar:{
            position:{x:665, y:1017}
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/screen-config.js
// module id = 8
// module chunks = 0